var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.info),expression:"info"}],staticClass:"info-tooltip"},[_c('img',{attrs:{"src":require("@/assets/icons/information.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }